// Shared brand styling for MUI Menu popovers, so Dropdown and SplitButton (and
// any future menu) look identical. Brand surface, radius, shadow, type.

export const menuPaperSx = {
  background: "var(--surface-card, #fff)",
  color: "var(--on-surface, #0f172a)",
  border: "1px solid var(--surface-border, #e6e8ec)",
  borderRadius: "var(--radius-md, 8px)",
  boxShadow: "var(--shadow-pop, 0 8px 24px rgba(15,23,42,0.14))",
  marginTop: "6px",
  minWidth: 180,
  "& .MuiList-root": { padding: "6px" },
};

export const menuItemSx = {
  fontFamily: "var(--font-body, 'Helvetica Neue', Arial, sans-serif)",
  fontSize: 13,
  color: "var(--on-surface, #0f172a)",
  borderRadius: "var(--radius-sm, 4px)",
  padding: "8px 10px",
  gap: "10px",
  minHeight: 0,
  "&:hover": { background: "var(--surface-sunken, #f1f5f9)" },
  "&.Mui-selected": {
    background: "var(--accent-soft, #e8f7f5)",
    color: "var(--accent-strong, #157a70)",
    fontWeight: 600,
  },
  "&.Mui-selected:hover": { background: "var(--accent-soft, #e8f7f5)" },
};

export const menuItemDestructiveSx = {
  ...menuItemSx,
  color: "var(--danger, #bc1b1b)",
  "&:hover": { background: "rgba(188,27,27,0.08)" },
};
